<template>
  <div class="app-header">
    <a
      href="https://www.pilates.com/"
      title="Visit Balanced Body"
      target="_blank"
    >
      <img
        src="@/assets/images/bb-logo-horz-clr.svg"
        alt="Balanced Body logo"
        class="logo"
      />
    </a>
    <!-- <nav>
      <a href="https://www.pilates.com/company/" target="_blank">Company</a>
      <a href="https://www.pilates.com/pilates/" target="_blank">Pilates</a>
      <a href="https://www.pilates.com/education/" target="_blank">Education</a>
      <a href="https://www.pilates.com/community/" target="_blank">Community</a>
      <a href="https://thecore.balancedbody.com" target="_blank">The Core</a>
      <a href="https://www.pilates.com/store/" target="_blank">Store</a>
    </nav> -->
  </div>
</template>

<script>
export default {
  name: "AppHeader"
};
</script>

<style scoped>
.app-header {
  display: flex;
  flex-flow: column;
  height: 80px;
  justify-content: center;
  border-bottom: 1px solid #adadad;
}

.logo {
  width: 60%;
  max-width: 300px;
  margin: 0 auto;
  display: block;
}

nav {
  display: none;
}

@media only screen and (min-width: 800px) {
  .app-header {
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    max-width: 870px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .logo {
    width: 300px;
  }

  nav {
    display: block;
  }

  nav a {
    font-family: var(--roboto);
    font-size: 16rem;
    line-height: 1;
    color: var(--text-gray);
    border-right: 1px solid var(--text-gray);
    padding: 0 5px;
    display: inline-block;
    text-decoration: none;
  }

  nav a:last-of-type {
    border-right: none;
  }

  nav a:hover {
    text-decoration: underline;
  }
}
</style>
